import { css } from 'styled-components';

import {
	maxWidth, padding, margin, elements, mobileOptions, minWidth, hoverEffects,
} from './props';

export const flex = css`
	display: flex;
	align-items: ${props => (props.align || 'center')};
	justify-content: ${props => (props.justify || 'center')};
	flex-wrap: ${props => (props.wrap ? 'wrap' : 'nowrap')};
	${props => props.flex && `flex: ${props.flex}`};
	${props => props.direction && `flex-direction: ${props.direction}`};
	width: ${props => (props.autoWidth ? 'auto' : '100%')};
	height: ${props => (props.autoHeight ? 'auto' : '100%')};
	${maxWidth};
	${minWidth};
	${padding};
	${margin};
	${mobileOptions};
	${hoverEffects};
	
	${elements};
`;

export const grid = css`
	${padding};
	${margin};
	display: grid;
	gap: ${props => props.gap || '16px'};
	grid-template-columns: repeat(auto-fill, ${props => props.elementWidth || '300px'});
	justify-items: center;
	justify-content: center;
	width: 100%;
`;
